import { Resource } from '../Resource';
import * as methods from './../methods';
import * as transformers from './../transformers';
const rootPath = 'network_organizations';
// eslint-disable-next-line no-shadow
export var AdherentFarmTrialStatus;
(function (AdherentFarmTrialStatus) {
    AdherentFarmTrialStatus[AdherentFarmTrialStatus["ongoing"] = 0] = "ongoing";
    AdherentFarmTrialStatus[AdherentFarmTrialStatus["expires_soon"] = 1] = "expires_soon";
    AdherentFarmTrialStatus[AdherentFarmTrialStatus["expired"] = 2] = "expired";
    AdherentFarmTrialStatus[AdherentFarmTrialStatus["over"] = 3] = "over";
})(AdherentFarmTrialStatus || (AdherentFarmTrialStatus = {}));
const fromRawOrgMailingAddress = (raw) => ({
    addressLine1: raw.address_line_1,
    addressLine2: raw.address_line_2,
    city: raw.address_city,
    countryCode: raw.country,
    zipCode: raw.address_zip
});
const fromRaw = ({ id, organization, network, trial, since, until, converted_at, member_count, trial_status }) => ({
    id,
    org: {
        billingStatus: organization.billing_status,
        id: organization.id,
        membershipCode: organization.code,
        companyName: organization.company_name,
        name: organization.name,
        membersCount: member_count,
        owner: {
            email: organization.owner.email,
            fullName: organization.owner.name,
            phone: organization.owner.phone
        },
        address: fromRawOrgMailingAddress(organization.mailing_address),
        siret: organization.siret
    },
    networkId: network,
    isTrial: trial,
    since,
    until,
    convertedAt: converted_at,
    trialStatus: trial_status
});
/**
 * information about the organizations that part of a network
 */
const networkOrgs = Resource((requesterBuilder) => {
    const getMany = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: transformers.paginatedResponse(fromRaw),
            params: {
                query: {
                    limit: query?.limit,
                    offset: query?.offset,
                    active: query?.isActive,
                    network: query?.networkId,
                    organization: query?.orgId,
                    trial: query?.isTrial,
                    q: query?.q,
                    billing_statuses: query?.billingStatus,
                    sort_by: query?.sortBy,
                    sort_order: query?.sortOrder,
                    trial_status: query?.trialStatus
                }
            }
        }
    });
    const getCSV = (query) => requesterBuilder({
        path: `${rootPath}/export`,
        requestCtx: {
            method: 'GET',
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            parse: (x) => x.blob(),
            transform: (blob) => blob,
            params: {
                query: {
                    network: query.networkId,
                    trial: query.isTrial
                }
            }
        }
    });
    const keysToInvalidate = [getMany().invalidationKey];
    return {
        get: methods.get({ fromRaw, requesterBuilder, rootPath }),
        getMany,
        getAllPagesStillActive: methods.getAllPages({ getMany, query: { isActive: true } }),
        getPage: methods.getPage({ getMany }),
        remove: (networkId) => requesterBuilder({
            path: `${rootPath}/${networkId}/remove`,
            requestCtx: { method: 'POST' },
            keysToInvalidate
        }),
        convertToPaidNetwork: (networkId) => requesterBuilder({
            path: `${rootPath}/${networkId}/convert_trial`,
            requestCtx: { method: 'POST' },
            keysToInvalidate
        }),
        download: getCSV
    };
});
export default networkOrgs;
